import { request } from "@/service/request";
import { HttpResponse } from "@/service/common/entity/HttpResponse";
import { ewodHost } from "@/config/host";
import { ProductAliInfoResDTO } from "../entity/ProductAliInfoResDTO";
/**
 * 获取阿里产品信息
 * @returns
 */
export function getAliProductInfo(params: {
  aliProductId: string;
}): Promise<HttpResponse<ProductAliInfoResDTO>> {
  return request({
    url: `${ewodHost}/product/getAliProductInfo`,
    method: "get",
    params,
    withCredentials: true,
  });
}
